/**
 * AIクォータ超過ダイアログ
 *
 * 月間トークン利用上限に達した際に表示するモーダル
 */

import React from 'react';
import { QuotaInfo } from '../types/api';

interface QuotaExceededDialogProps {
  isOpen: boolean;
  onClose: () => void;
  quotaInfo: QuotaInfo | null;
  resetDate: string | null;
}

const QuotaExceededDialog: React.FC<QuotaExceededDialogProps> = ({
  isOpen,
  onClose,
}) => {
  if (!isOpen) {
    return null;
  }

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 9999,
      }}
      onClick={onClose}
    >
      <div
        style={{
          backgroundColor: 'white',
          borderRadius: '10px',
          border: '1px solid #E5E7EB',
          boxShadow:
            '0px 20px 25px -5px rgba(0,0,0,0.1), 0px 8px 10px -6px rgba(0,0,0,0.1)',
          width: '512px',
          padding: '32px',
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Title */}
        <h2
          style={{
            fontFamily: 'Inter, Noto Sans JP, sans-serif',
            fontWeight: 600,
            fontSize: '18px',
            lineHeight: '28px',
            letterSpacing: '-0.44px',
            color: '#0D357F',
            margin: '0 0 16px 0',
          }}
        >
          AIの利用上限に達しました
        </h2>

        {/* Message */}
        <p
          style={{
            fontFamily: 'Inter, Noto Sans JP, sans-serif',
            fontWeight: 400,
            fontSize: '16px',
            lineHeight: '25.6px',
            letterSpacing: '-0.31px',
            color: '#364153',
            margin: '0 0 32px 0',
          }}
        >
          当月のAIの利用上限に達したため、文章を生成できません。次月より再度AIを利用可能となります。
        </p>

        {/* Close Button */}
        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
          }}
        >
          <button
            onClick={onClose}
            style={{
              backgroundColor: '#0D357F',
              color: 'white',
              border: 'none',
              borderRadius: '6px',
              padding: '10px 24px',
              fontFamily: 'Noto Sans JP, sans-serif',
              fontSize: '14px',
              fontWeight: 600,
              cursor: 'pointer',
              transition: 'background-color 0.2s',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = '#0A2A5E';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = '#0D357F';
            }}
          >
            閉じる
          </button>
        </div>
      </div>
    </div>
  );
};

export default QuotaExceededDialog;
